import api from "./api";

const SESSION_KEY = "xs_visit_session";

function ensureSession() {
  let s = sessionStorage.getItem(SESSION_KEY);
  if (!s) {
    s = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    sessionStorage.setItem(SESSION_KEY, s);
  }
  return s;
}

const recent = new Map(); // path -> ts; in-memory dedup
function shouldEmit(key, ttl = 5000) {
  const now = Date.now();
  const last = recent.get(key) || 0;
  if (now - last < ttl) return false;
  recent.set(key, now);
  return true;
}

export function track(event, payload = {}) {
  ensureSession();
  // Don't track admin pages
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) return;
  // Don't track in dev visual-edit overlay (best-effort)
  const key = `${event}:${payload.path || ""}:${payload.post_slug || ""}`;
  if (event === "page_view" && !shouldEmit(key)) return;
  const body = {
    event,
    path: payload.path ?? (typeof window !== "undefined" ? window.location.pathname : null),
    post_slug: payload.post_slug ?? null,
    referrer: payload.referrer ?? (typeof document !== "undefined" ? document.referrer : null),
    media_type: payload.media_type ?? null,
    duration: payload.duration ?? null,
    progress: payload.progress ?? null,
  };
  try {
    api.post("/analytics/event", body).catch(() => {});
  } catch {}
}

export function trackPageView(path, post_slug) {
  track("page_view", { path, post_slug });
}

export function trackMediaPlay(media_type, duration) {
  track("media_play", { media_type, duration });
}

export function trackMediaComplete(media_type, duration) {
  track("media_complete", { media_type, duration });
}

export function trackProfileEvent(event, moduleKey, gesture) {
  track(event, { post_slug: `profile:${moduleKey}`, media_type: gesture ? `gesture:${gesture}` : null });
}
